<i18n lang="yaml">
ja:
  fields:
    personal:
      areas: '対応エリア'
  pressEnter: 'エリア入力後 [Enter] キーを押してください。'
</i18n>
<script setup lang="ts">
import { ref } from 'vue'
import { storeToRefs } from 'pinia'

import { removeItem } from '@/modules/utils'
import { vEnter } from '@/directives/enter'

import { useI18n } from 'vue-i18n'
import { use as useSession } from '@/stores/session'

import ItemTags from './ProfileTags.vue'

useI18n()
const session = useSession()
const { agent, active } = storeToRefs(session)
const { editing, data } = defineProps(['editing', 'data'])

const value = ref('')

function addTag(event: Event) {
  if (
    event instanceof KeyboardEvent &&
    event.target instanceof HTMLInputElement &&
    event.target.value
  ) {
    if (!data.personal.areas) {
      data.personal.areas = []
    }
    data.personal.areas.push(event.target.value)
    value.value = ''
  }
}

function onDelete(event: Event) {
  if (
    event instanceof KeyboardEvent &&
    event.target instanceof HTMLInputElement &&
    !event.target.value &&
    data.personal.areas.length
  ) {
    data.personal.areas.splice(data.personal.areas.length - 1, 1)
  }
}
</script>
<template>
  <div class="field" v-if="agent">
    <h3 class="w6 t16" v-t="'fields.personal.areas'" />
    <template v-if="editing">
      <p class="t14 cl-gray" v-t="'pressEnter'" />
      <div class="tags ro i-box u-row" @click.stop>
        <template v-if="data.personal.areas">
          <div class="tag u-row" v-for="tag of data.personal.areas" :key="tag">
            <span>{{ tag }}</span>
            <button type="button" @click="removeItem(data.personal.areas, tag)">
              <FontAwesomeIcon class="icon" :icon="['fas', 'circle-xmark']" />
            </button>
          </div>
        </template>
        <input type="text" v-model="value" v-enter="addTag" @keyup.delete="onDelete" />
      </div>
    </template>
    <ItemTags :tags="agent.personal.areas" v-else-if="agent.personal.areas || active" />
  </div>
</template>
<style scoped>
.tags.options {
  margin-top: -1px;
}
.tags.ro {
  padding: 4px 12px 12px 12px;
}
input {
  min-width: 80px;
  flex: 1;
  height: 36px;
  margin-top: 8px;
}
</style>
